import styles from './ProjectGrid.module.css';
import Arrow from '../assets/arrowTopRight.jsx';
import Close from '../assets/Close.jsx';
import Pixel from '../assets/Pixel.jsx';
import ArrowDown from '../assets/ArrowDown.jsx';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import {useRef, useEffect, useState, useContext} from 'react';
import ReactDOM from "react-dom"
import toSentenceCase from '../utilities/sentenceCase.js';
import { useLocation, useParams, useNavigate } from "react-router-dom";
import VideoControlsEl from '../components/common/VideoControls.jsx';
import { videoControls } from '../utilities/videoControls.js';
import { SmootherContext } from '../components/common/SmootherContext.js';
import QuickView from './common/Quickview.jsx';

export default function ProjectGrid({ title, items, fromSearch = "no" }) {

    // getting the smooth scroll context to refresh when see more is clicked
    const smoother = useContext(SmootherContext);

    // get the current lang for routing
    const { lang } = useParams();

    // creating state between featured and all projects
    const { pathname } = useLocation();
    const isFeatured = !pathname.includes("/production/all");
    const visibleCount = isFeatured ? 14 : 12;

    // showing 12 items be default. This should become a prop so we can use this component on the "all" page as well
    const [showAll, setShowAll] = useState(false);
    const visibleItems = showAll ? items : items.slice(0,visibleCount);

    function showAllWork() {
        setShowAll(true);
        smoother.refresh();
    }

    function playHoverVideo(e) {
        const cell = e.currentTarget;
        const video = cell.querySelector("video");
        if (typeof video != "undefined" && video != null) {
            video.play();
        }
        
    }

    function pauseHoverVideo(e) {
        const cell = e.currentTarget;
        const video = cell.querySelector("video");
        if (typeof video != "undefined" && video != null) {
            video.pause();
        }
    }

    const [quickViewOpen, setQuickViewOpen] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const [isAnimating, setIsAnimating] = useState(false);

    const handleOpenQuickView = (project) => {
        if (quickViewOpen || isAnimating) return;
        setSelectedProject(project);
        setQuickViewOpen(true);
    };

    const handleCloseQuickView = () => {
        setIsAnimating(true);
        setQuickViewOpen(false);

        setTimeout(() => {
            setSelectedProject(null); // optional: clear project after closing
            setIsAnimating(false);
        }, 600);
    };

    // setting up an item counter to manage large cells
    let itemCount = 0;

    return (
        <div className={`${styles.project_grid} ${lang === "ko" && styles.lang_ko}`}>

            <div className={styles.intro}>

                <div className={`${styles.section_title} preserve-line-breaks`}>
                    <h1>{title}</h1>
                </div>

                {fromSearch === "no" && (

                    <div className={styles.filter}>
                        <ul>
                            <li><a href={`/${lang}/production`} className={`${isFeatured ? styles.active : null}`}>▪ {lang === "ko" ? "추천" : "Featured"}</a></li>
                            <li><a href={`/${lang}/production/all`} className={`${isFeatured ? null : styles.active}`}>▪ {lang === "ko" ? "모두" : "All"}</a></li>
                        </ul>
                    </div>

                )}

            </div>

            <div className={styles.grid}>

                {visibleItems.filter(item => item.fields.gridImage).map((item, i) => {

                    ++itemCount;

                    // going to ignore large size for the "all" grid
                    let itemSize = styles.regular;
                    if (isFeatured && fromSearch != "yes") {
                        itemSize = item.fields.gridSize === "large" ? styles.large : styles.regular;
                    }

                    if (itemCount > 2) {
                        itemCount = 1;
                    }

                    if (isFeatured && fromSearch != "yes") {
                        if (item.fields.gridSize === "large") {
                            itemCount = 0;
                        }
                    }

                    let itemAlignClass = styles.left;
                    if (itemCount % 2 == 0) {
                        itemAlignClass = styles.right;
                    }

                    let itemVideoClass = styles.no_video;
                    let hasVideo = false;
                    if (item.fields.gridVideoLoopHdLink) {
                        itemVideoClass = styles.with_video;
                        hasVideo = true;
                    }

                    const videoEvents = hasVideo
                    ? {
                        onMouseOver: playHoverVideo,
                        onMouseLeave: pauseHoverVideo
                        }
                    : {};

                    return (

                        <div className={`${styles.cell} ${styles.project} ${itemSize} ${itemAlignClass} ${itemVideoClass}`} {...videoEvents} key={i} data-count={itemCount}>
                            <a onClick={(e) => { e.preventDefault(); handleOpenQuickView(item); }} href={`/${lang}/projects/${item.fields.slug}`}>
                                <div className={styles.media}>
                                    <img
                                        src={`https:${item.fields.gridImage.fields.file.url}`}
                                        alt={item.fields.title}
                                        width={item.fields.gridImage.fields.file.details.image.width}
                                        height={item.fields.gridImage.fields.file.details.image.height}
                                        className="absolute-cover"
                                    />

                                    {item.fields.gridVideoLoopHdLink && (
                                        <video className={`${styles.hover_video} absolute-cover`} playsInline muted loop>
                                            <source src={item.fields.gridVideoLoopHdLink} type="video/mp4" />
                                        </video>
                                    )}

                                </div>

                                <div className={styles.info}>
                                    <h2 className={styles.title}>{item.fields.title}</h2>
                                </div>

                                <div className={styles.hover_info}>
                                    <div className={styles.contents}>
                                        <h2>{toSentenceCase(item.fields.title)}</h2>
                                    </div>
                                    
                                </div>

                                <div className={styles.hover_pixel}></div>

                            </a>

                            {item.fields.gridCaption && (
                                <div className={styles.caption}>
                                    <p>{item.fields.gridCaption}</p>
                                </div>)}

                        </div>
            

                    );

                    

                })}

            </div>

            {!showAll && items.length > visibleCount && (
                <div className={styles.seemore_wrap}>
                    <button className="see_more" onClick={() => showAllWork()}>
                        {lang === "ko" ? "모두 보기" : "SEE MORE"} <ArrowDown />
                    </button>
                </div>
            )}

            <QuickView
                isOpen={quickViewOpen}
                onClose={handleCloseQuickView}
                isAnimating={isAnimating}
                project={selectedProject}
            />

        </div>
    )
}